/**
 * Форматирование телефона в соответствии с форматом разных стран. Страна определяется по международному коду в самом телефоне. Логика взята из компонента react-phone-input-2, но работает независимо от него.
 */

import CountryData from './CountryData.js';
import startsWith from 'lodash.startswith';
import reduce from 'lodash.reduce';

export const formatPhone = (phone) => {
  //В оригинале эти параметры беруться из props. Оттуда же беруться параметры конструктора CountryData
  const country = 'ru';
  const disableCountryCode = false;

  const { onlyCountries, hiddenAreaCodes } = new CountryData(
    false,
    false,
    '',
    [],
    [],
    [],
    [],
    null,
    null,
    null,
    {},
    '+',
    '... ... ... ... ..',
    false,
  );

  const inputNumber = (phone || '').replace(/\D/g, '');

  let countryGuess;
  if (inputNumber.length > 1) {
    // Country detect by phone
    countryGuess =
      guessSelectedCountry(inputNumber.substring(0, 6), country, onlyCountries, hiddenAreaCodes) ||
      0;
  } else if (country) {
    // Default country
    countryGuess = onlyCountries.find((o) => o.iso2 == country) || 0;
  } else {
    // Empty params
    countryGuess = 0;
  }

  const dialCode =
    inputNumber.length < 2 && countryGuess && !startsWith(inputNumber, countryGuess.dialCode)
      ? countryGuess.dialCode
      : '';

  return inputNumber === '' && countryGuess === 0
    ? ''
    : formatNumber(
        (disableCountryCode ? '' : dialCode) + inputNumber,
        countryGuess.name ? countryGuess : undefined,
      );
};

const formatNumber = (text, country) => {
  if (!country) return text;

  const { format } = country;
  //В оригинале эти параметры беруться из props
  const disableCountryCode = false;
  const enableAreaCodeStretch = false;
  const enableLongNumbers = false;
  const autoFormat = true;
  const prefix = '+';

  let pattern;
  if (disableCountryCode) {
    pattern = format.split(' ');
    pattern.shift();
    pattern = pattern.join(' ');
  } else {
    if (enableAreaCodeStretch && country.isAreaCode) {
      pattern = format.split(' ');
      pattern[1] = pattern[1].replace(/\.+/, ''.padEnd(country.areaCodeLength, '.'));
      pattern = pattern.join(' ');
    } else {
      pattern = format;
    }
  }

  if (!text || text.length === 0) {
    return disableCountryCode ? '' : prefix;
  }

  // for all strings with length less than 3, just return it (1, 2 etc.)
  // also return the same text if the selected country has no fixed format
  if ((text && text.length < 2) || !pattern || !autoFormat) {
    return disableCountryCode ? text : prefix + text;
  }

  const formattedObject = reduce(
    pattern,
    (acc, character) => {
      if (acc.remainingText.length === 0) {
        return acc;
      }

      if (character !== '.') {
        return {
          formattedText: acc.formattedText + character,
          remainingText: acc.remainingText,
        };
      }

      const [head, ...tail] = acc.remainingText;

      return {
        formattedText: acc.formattedText + head,
        remainingText: tail,
      };
    },
    {
      formattedText: '',
      remainingText: text.split(''),
    },
  );

  let formattedNumber;
  if (enableLongNumbers) {
    formattedNumber = formattedObject.formattedText + formattedObject.remainingText.join('');
  } else {
    formattedNumber = formattedObject.formattedText;
  }

  // Always close brackets
  if (formattedNumber.includes('(') && !formattedNumber.includes(')')) formattedNumber += ')';
  return formattedNumber;
};

const guessSelectedCountry = (inputNumber, country, onlyCountries, hiddenAreaCodes) => {
  //В оригинале эти параметры беруться из props
  const enableAreaCodes = false;

  // if enableAreaCodes == false, try to search in hidden area codes to detect area code correctly
  // then search and insert main country which has this area code
  // https://github.com/bl00mber/react-phone-input-2/issues/201
  if (enableAreaCodes === false) {
    let mainCode;
    hiddenAreaCodes.some((country) => {
      if (startsWith(inputNumber, country.dialCode)) {
        onlyCountries.some((o) => {
          if (country.iso2 === o.iso2 && o.mainCode) {
            mainCode = o;
            return true;
          }
        });
        return true;
      }
    });
    if (mainCode) return mainCode;
  }

  const secondBestGuess = onlyCountries.find((o) => o.iso2 == country);
  if (inputNumber.trim() === '') return secondBestGuess;

  const bestGuess = onlyCountries.reduce(
    (selectedCountry, country) => {
      if (startsWith(inputNumber, country.dialCode)) {
        if (country.dialCode.length > selectedCountry.dialCode.length) {
          return country;
        }
        if (
          country.dialCode.length === selectedCountry.dialCode.length &&
          country.priority < selectedCountry.priority
        ) {
          return country;
        }
      }
      return selectedCountry;
    },
    { dialCode: '', priority: 10001 },
    this,
  );

  if (!bestGuess.name) return secondBestGuess;
  return bestGuess;
};
